import React from "react"

import { FiLink2, FiCode } from "react-icons/fi"

import { subnav } from "./Navigation.module.scss"

const Navigation = ({ item, microcopy, hideInPageNav = false }) => (
  <nav className={subnav}>
    {!hideInPageNav && (
      <nav>
        <FiLink2 />
        {item.params?.[0] && (
          <a href="#request">{microcopy.text("reference.titles.request")}</a>
        )}
        {item.responses?.[0] && (
          <a href="#response">{microcopy.text("reference.titles.response")}</a>
        )}
        {item.samples?.[0] && (
          <a href="#request-example">
            {microcopy.text("reference.titles.request_example")}
          </a>
        )}
        {item.defaultResponse?.resources?.[0] && (
          <a href="#response-example">
            {microcopy.text("reference.titles.response_example")}
          </a>
        )}
      </nav>
    )}

    {microcopy.code === "en" && (
      <a href={item.reportErrorFormUrl} data-source>
        <FiCode />
        {microcopy.text("guides.titles.send_feedback")}
      </a>
    )}
  </nav>
)

export default Navigation
